import React, { PropTypes } from 'react';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';

const LandingMeta = ({ seo_description, seo_robots, seo_title, url_stem, seo_canonical_url,
                       script_tags }) => (
  <Meta
    title={seo_title}
    meta={[{
      name: 'robots',
      content: seo_robots,
    }, {
      name: 'description',
      content: seo_description,
    }]}
    link={[
      {
        rel: 'canonical',
        href: getCanonicalURL(seo_canonical_url || url_stem)
      }
    ]}
    script={script_tags || []}
  />
);

LandingMeta.propTypes = {
  seo_description: PropTypes.string,
  seo_robots: PropTypes.string,
  seo_title: PropTypes.string,
  url_stem: PropTypes.string,
  seo_canonical_url: PropTypes.string,
};

export default LandingMeta;
